import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { navegarComCtrl } from "../../utils/solicitacoes/navegacao";
import { CustomTable } from "../../componentes/table/CustomTable";
import { CustomDropdown } from "../../componentes/dropdown/CustomDropdown";
import StatusBadge from "../../components/solicitacoes/Shared/StatusBadge";
import GraficosBasicos from "../../components/solicitacoes/Dashboard/GraficosBasicos";
import DashboardProcessoLayout, { Campo, INPUT_CLASS } from "../../components/solicitacoes/Dashboard/DashboardProcessoLayout";
import { useDashboardProcesso } from "../../hooks/solicitacoes/useDashboardProcesso";
import CadastroClienteService from "../../services/resource/cadastroClienteService";
import UsuarioService from "../../services/resource/usuarioService";
import { STATUS_CONFIG } from "../../utils/solicitacoes/statusConfig";
import { kpisBasicos } from "../../utils/solicitacoes/chartOptions";

const service = new CadastroClienteService();
const usuarioService = new UsuarioService();

const STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(([value, info]) => ({ value, label: info.label }));

const TIPO_SOLICITACAO_OPTIONS = [
    { value: "NOVO_CADASTRO", label: "Novo Cadastro" },
    { value: "ALTERACAO_CADASTRO", label: "Alteração de Cadastro" },
    { value: "ALTERACAO_ENDERECO", label: "Alteração de Endereço" },
    { value: "TROCA_RAZAO_SOCIAL", label: "Troca de Razão Social" },
    { value: "REATIVACAO", label: "Reativação" },
];
const TIPO_SOLICITACAO_LABELS = TIPO_SOLICITACAO_OPTIONS.reduce((acc, o) => ({ ...acc, [o.value]: o.label }), {});

const DIA_VISITA_LABELS = {
    SEGUNDA_FEIRA: "Segunda-feira",
    TERCA_FEIRA: "Terça-feira",
    QUARTA_FEIRA: "Quarta-feira",
    QUINTA_FEIRA: "Quinta-feira",
    SEXTA_FEIRA: "Sexta-feira",
    SABADO: "Sábado",
};

const FILTROS_INICIAIS_EXTRA = {
    filialNome: "", tipoSolicitacao: null, clienteNome: "", clienteCodigo: "", cpfCnpj: "",
    cidade: "", rota: "", subCanalNome: "", status: null, solicitanteId: null,
};

const COLUNAS = [
    { key: "tipoSolicitacao", label: "Tipo da Solicitação", render: v => TIPO_SOLICITACAO_LABELS[v] || v },
    { key: "clienteNome", label: "Cliente" },
    { key: "nomeCliente", label: "Nome" },
    { key: "razaoSocial", label: "Razão Social" },
    { key: "fantasia", label: "Nome Fantasia" },
    { key: "clienteCodigo", label: "Código Cliente" },
    { key: "novoCodigoCliente", label: "Novo Código Cliente" },
    { key: "cpfCnpj", label: "CPF/CNPJ" },
    { key: "enderecoCompleto", label: "Endereço Completo" },
    { key: "cidade", label: "Cidade" },
    { key: "rota", label: "Rota" },
    { key: "subCanalNome", label: "SubCanal" },
    { key: "diaVisita", label: "Dia de Visita", render: v => DIA_VISITA_LABELS[v] || v },
    { key: "status", label: "Status", render: v => <StatusBadge status={v} />, center: true },
    { key: "etapaAtual", label: "Etapa Atual" },
    { key: "solicitanteNome", label: "Solicitante" },
    { key: "dataSolicitacao", label: "Data", format: "date" },
];

export default function RelatorioCadastroCliente() {
    const navigate = useNavigate();
    const [usuarios, setUsuarios] = useState([]);

    const { filtros, setFiltros, limparFiltros, pesquisar, linhas, dashboard, loading } = useDashboardProcesso({
        service, chaveFiltros: "solicitacoes.cadastroCliente.filtros", filtrosIniciaisExtra: FILTROS_INICIAIS_EXTRA,
    });

    useEffect(() => {
        document.title = "MyDash | Cadastro de Cliente";
    }, []);

    useEffect(() => {
        usuarioService.listarUsuarios().then(res => setUsuarios(res.data)).catch(() => setUsuarios([]));
    }, []);

    function setFiltro(campo, valor) {
        setFiltros(prev => ({ ...prev, [campo]: valor }));
    }

    return (
        <DashboardProcessoLayout
            titulo="Cadastro de Cliente"
            onNovaSolicitacao={() => navigate("/solicitacoes/nova")}
            loading={loading}
            filtros={filtros}
            onFiltroChange={setFiltro}
            onPesquisar={pesquisar}
            onLimparFiltros={limparFiltros}
            kpis={kpisBasicos(dashboard, "fa fa-id-card")}
            graficos={<GraficosBasicos dashboard={dashboard} />}
            filtrosExtras={(
                <>
                    <Campo label="Filial">
                        <input type="text" value={filtros.filialNome} onChange={e => setFiltro("filialNome", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Tipo da Solicitação">
                        <CustomDropdown value={filtros.tipoSolicitacao} onChange={e => setFiltro("tipoSolicitacao", e.value)} options={TIPO_SOLICITACAO_OPTIONS}
                            placeholder="Todos" showClear />
                    </Campo>
                    <Campo label="Cliente">
                        <input type="text" value={filtros.clienteNome} onChange={e => setFiltro("clienteNome", e.target.value)}
                            placeholder="Razão social, fantasia ou nome" className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Código Cliente">
                        <input type="text" value={filtros.clienteCodigo} onChange={e => setFiltro("clienteCodigo", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="CPF/CNPJ">
                        <input type="text" value={filtros.cpfCnpj} onChange={e => setFiltro("cpfCnpj", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Cidade">
                        <input type="text" value={filtros.cidade} onChange={e => setFiltro("cidade", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Rota">
                        <input type="text" value={filtros.rota} onChange={e => setFiltro("rota", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="SubCanal">
                        <input type="text" value={filtros.subCanalNome} onChange={e => setFiltro("subCanalNome", e.target.value)} className={INPUT_CLASS} />
                    </Campo>
                    <Campo label="Status">
                        <CustomDropdown value={filtros.status} onChange={e => setFiltro("status", e.value)} options={STATUS_OPTIONS}
                            placeholder="Todos os status" showClear />
                    </Campo>
                    <Campo label="Solicitante">
                        <CustomDropdown value={filtros.solicitanteId} onChange={e => setFiltro("solicitanteId", e.value)} options={usuarios}
                            optionValue="id" optionLabel="nome" placeholder="Todos os solicitantes" showClear filter />
                    </Campo>
                </>
            )}
        >
            <CustomTable
                data={linhas}
                columns={COLUNAS}
                loading={loading}
                pagination
                pageSize={20}
                exportable
                showHeader={false}
                className="text-[11px] border shadow-card rounded-xl"
                exportFilename="dashboard_cadastro_cliente"
                footer={() => null}
                onRowSelect={(row, e) => navegarComCtrl(navigate, `/solicitacoes/${row.solicitacaoId}`, e)}
            />
        </DashboardProcessoLayout>
    );
}
